/* eslint-disable no-use-before-define */
/* eslint-disable no-inner-declarations */
/* eslint-disable no-undef */
import RestaurantSource from '../../data/restaurant-source';
import { restoDetailTemplate } from '../templates/template-creator';
import UrlParser from '../../routes/url-parser';
import LikeButtonInitiator from '../../utils/like-button-initiator';
import '../components/customer-reviews';
import '../components/loading-element';
import '../components/fail-request';

const Detail = {
  async render() {
    return `
        <article class="container-detail" id="detail"><div id="likeButtonContainer"></div></article>
      `;
  },

  async afterRender() {
    const url = UrlParser.parseActiveUrlWithoutCombiner();

    const detail = document.getElementById('detail');
    const loading = document.querySelector('loading-element');
    const fail = document.querySelector('fail-request');
    loading.style.display = 'block';
    fail.style.display = 'none';
    try {
      const resto = await RestaurantSource.detailResto(url.id);
      detail.innerHTML += restoDetailTemplate(resto.restaurant);

      LikeButtonInitiator.init({
        likeButtonContainer: document.querySelector('#likeButtonContainer'),
        resto: resto.restaurant,
      });

      const food = document.getElementById('listmakanan');
      resto.restaurant.menus.foods.forEach((item) => {
        food.innerHTML += `
        <li>${item.name}</li>
    `;
      });
      const drink = document.getElementById('listminuman');
      resto.restaurant.menus.drinks.forEach((item) => {
        drink.innerHTML += `
        <li>${item.name}</li>
    `;
      });
      const reviewContainer = document.getElementById('reviews');
      const reviewsEl = document.createElement('customer-reviews');
      reviewsEl.review = resto.restaurant.customerReviews;
      reviewContainer.appendChild(reviewsEl);

      const form = document.getElementById('review-form');

      form.addEventListener('submit', formSubmit);

      async function formSubmit(e) {
        e.preventDefault();
        const formData = new FormData();
        formData.append('id', resto.restaurant.id);
        formData.append('nama', document.getElementById('nama').value);
        formData.append('review', document.getElementById('review').value);

        const data = {
          id: resto.restaurant.id,
          name: document.getElementById('nama').value,
          review: document.getElementById('review').value,
        };

        const post = await RestaurantSource.postReview(data);
        if (post.status === 201) {
          const nama = document.getElementById('nama');
          const review = document.getElementById('review');
          nama.setAttribute('value', '');
          review.setAttribute('value', '');
          Swal.fire({
            title: 'Berhasil!',
            text: 'Berhasil menambahkan review',
            icon: 'success',
            confirmButtonText: 'OK',
            allowOutsideClick: false,
          }).then((result) => {
            if (result.isConfirmed) {
              window.location.reload();
            }
          });
        }
      }
    } catch {
      fail.style.display = 'block';
      const footer = document.querySelector('footer');
      const main = document.getElementById('main');
      const hero = document.getElementById('hero');
      main.style.display = 'none';
      hero.style.display = 'none';
      footer.style.display = 'none';
    } finally {
      loading.style.display = 'none';
    }
  },
};

export default Detail;
